import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { Layout } from "./components/Layout";
import { ScrollToTop } from "./components/ScrollToTop";
import { PageTracker } from "./components/PageTracker";
import { ThemeProvider } from "./contexts/ThemeContext";
import { HelmetProvider } from "react-helmet-async";

// Initialize i18n
import "./i18n";

// Pages
import Home from "./pages/Home";
import About from "./pages/About";
import Soccer from "./pages/Soccer";
import Tennis from "./pages/Tennis";
import DancePilates from "./pages/DancePilates";
import SocialRunClub from "./pages/SocialRunClub";
import BliSponsor from "./pages/BliSponsor";
import Treningstider from "./pages/Treningstider";
import BarneakademiPage from "./pages/BarneakademiPage";
import UngdomsakademiPage from "./pages/UngdomsakademiPage";
import Rentals from "./pages/Rentals";
import Store from "./pages/Store";
import Contact from "./pages/Contact";
import Pricing from "./pages/Pricing";
import NewsArticle from "./pages/NewsArticle";
import NewsArchive from "./pages/NewsArchive";
import Styret from "./pages/Styret";
import Aarsmoeteprotokoll from "./pages/Aarsmoeteprotokoll";
import AarsmoeteprotokollYear from "./pages/AarsmoeteprotokollYear";
import Politiattest from "./pages/Politiattest";
import Fritidskortet from "./pages/Fritidskortet";
import StrategiSportsplan from "./pages/StrategiSportsplan";
import StrategiSportsplanDetail from "./pages/StrategiSportsplanDetail";
import Strategiplan from "./pages/Strategiplan";

// Tennis Booking Pages
import TennisLogin from "./pages/TennisLogin";
import TennisRegister from "./pages/TennisRegister";
import TennisBookingPage from "./pages/TennisBookingPage";
import TennisForgotPassword from "./pages/TennisForgotPassword";
import TennisMyBookings from "./pages/TennisMyBookings";

// Match Calendar
import MatchCalendar from "./pages/MatchCalendar";
import MatchAdmin from "./pages/MatchAdmin";

// Admin Panel
import AdminLogin from "./pages/AdminLogin";
import AdminPanel from "./pages/AdminPanel";

// Legal
import Personvern from "./pages/Personvern";

function App() {
  return (
    <HelmetProvider>
      <ThemeProvider>
        <BrowserRouter>
          <ScrollToTop />
          <PageTracker />
          <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
          <Route path="/soccer" element={<Soccer />} />
          <Route path="/tennis" element={<Tennis />} />
          <Route path="/tennis/login" element={<TennisLogin />} />
          <Route path="/tennis/register" element={<TennisRegister />} />
          <Route path="/tennis/forgot-password" element={<TennisForgotPassword />} />
          <Route path="/tennis/booking" element={<TennisBookingPage />} />
          <Route path="/tennis/mine-bookinger" element={<TennisMyBookings />} />
          <Route path="/tennis/admin" element={<Navigate to="/admin" replace />} />
          <Route path="/kamper" element={<MatchCalendar />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminPanel />} />
          <Route path="/admin/kamper" element={<MatchAdmin />} />
          <Route path="/dance-pilates" element={<DancePilates />} />
          <Route path="/social-run-club" element={<SocialRunClub />} />
          <Route path="/bli-sponsor" element={<BliSponsor />} />
          <Route path="/fotball/treningstider" element={<Treningstider />} />
          <Route path="/fotball/barneakademi" element={<BarneakademiPage />} />
          <Route path="/fotball/ungdomsakademi" element={<UngdomsakademiPage />} />
          <Route path="/rentals" element={<Rentals />} />
          <Route path="/store" element={<Store />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/nyheter" element={<NewsArchive />} />
          <Route path="/nyheter/:slug" element={<NewsArticle />} />
          <Route path="/styret" element={<Styret />} />
          <Route path="/aarsmoeteprotokoll" element={<Aarsmoeteprotokoll />} />
          <Route path="/aarsmoeteprotokoll/:year" element={<AarsmoeteprotokollYear />} />
          <Route path="/strategi-sportsplan" element={<StrategiSportsplan />} />
          <Route path="/strategi-sportsplan/strategiplan" element={<Strategiplan />} />
          <Route path="/strategi-sportsplan/:type" element={<StrategiSportsplanDetail />} />
          <Route path="/strategi-sportsplan/:type/:subtype" element={<StrategiSportsplanDetail />} />
          <Route path="/politiattest" element={<Politiattest />} />
          <Route path="/fritidskortet" element={<Fritidskortet />} />
          <Route path="/personvern" element={<Personvern />} />
        </Routes>
          </Layout>
          <Toaster position="top-right" richColors />
        </BrowserRouter>
      </ThemeProvider>
    </HelmetProvider>
  );
}

export default App;
